module.exports = __webpack_public_path__ + "media/images/rating_intermediate-b29e57911f87b38b2351cc4a0e12e055.png";